<template>
  <section class="sms-composer" :class="{ 'sms-composer-command': type === 'device-command' }">
    <div class="sms-composer-heading">
      <div>
        <h2>{{ type === 'device-command' ? 'Send configuration SMS command' : 'Send SMS' }}</h2>
        <p>Recipient: <strong>{{ normalizedRecipient || 'phone number is missing' }}</strong></p>
      </div>
      <span v-if="type === 'device-command'" class="sms-composer-badge">Configuration command</span>
    </div>

    <label class="form-label" :for="fieldId">Message</label>
    <textarea
      :id="fieldId"
      v-model="message"
      class="form-control"
      rows="4"
      :placeholder="type === 'device-command' ? 'Enter the device SMS command…' : 'Enter a notification message…'"
      :disabled="sending"
    />
    <div class="sms-composer-footer">
      <small>{{ message.length }} / 1600</small>
      <button
        type="button"
        class="btn sms-composer-send"
        :disabled="sending || !normalizedRecipient || !message.trim()"
        @click="send"
      >{{ sending ? 'Sending…' : 'Send SMS' }}</button>
    </div>
    <p v-if="error" class="sms-composer-error" role="alert">{{ error }}</p>
    <p v-if="success" class="sms-composer-success" role="status">SMS was accepted by Messente.</p>
  </section>
</template>

<script>
import axios from 'axios'
import { API_ENDPOINTS } from '@/config/api'

export default {
  name: 'SmsComposer',
  props: {
    recipient: { type: String, default: '' },
    type: {
      type: String,
      default: 'notification',
      validator: (value) => ['notification', 'device-command'].includes(value)
    }
  },
  data() {
    return { message: '', sending: false, error: '', success: false }
  },
  computed: {
    normalizedRecipient() {
      const recipient = String(this.recipient || '').replace(/\s+/g, '')
      return /^\+\d{7,15}$/.test(recipient) ? recipient : ''
    },
    fieldId() {
      return this.type === 'device-command' ? 'device-sms-message' : 'user-sms-message'
    }
  },
  watch: {
    recipient() {
      this.message = ''
      this.error = ''
      this.success = false
    }
  },
  methods: {
    async send() {
      if (!this.normalizedRecipient || !this.message.trim() || this.sending) return

      const confirmation = this.type === 'device-command'
        ? `Send this configuration command to ${this.normalizedRecipient}?\n\n${this.message.trim()}`
        : `Send SMS to ${this.normalizedRecipient}?`
      if (!window.confirm(confirmation)) return

      this.sending = true
      this.error = ''
      this.success = false
      try {
        await axios.post(`${API_ENDPOINTS.TIW_API}/sms`, {
          recipient: this.normalizedRecipient,
          text: this.message.trim(),
          type: this.type
        })
        this.success = true
        this.message = ''
      } catch (error) {
        this.error = error?.response?.data?.message || error?.response?.data?.error || 'SMS sending failed.'
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped>
.sms-composer { padding: 16px; border: 1px solid #dce3e6; border-radius: 9px; background: #fff; }
.sms-composer-command { border-color: #efc08c; background: #fffaf4; }
.sms-composer-heading { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 12px; }
.sms-composer-heading h2 { margin: 0; font-size: 15px; font-weight: 700; }
.sms-composer-heading p { margin: 4px 0 0; color: #687277; font-size: 12px; overflow-wrap: anywhere; }
.sms-composer-badge { padding: 3px 7px; border-radius: 999px; background: #f56600; color: #fff; font-size: 10px; font-weight: 700; white-space: nowrap; }
.sms-composer .form-label { margin-bottom: 5px; color: #40545e; font-size: 11px; font-weight: 700; }
.sms-composer textarea { resize: vertical; font-size: 13px; }
.sms-composer-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 8px; }
.sms-composer-footer small { color: #687277; }
.sms-composer-send { border-color: #f56600; background: #f56600; color: #fff; font-size: 12px; }
.sms-composer-send:hover:not(:disabled) { border-color: #d95700; background: #d95700; color: #fff; }
.sms-composer-error, .sms-composer-success { margin: 9px 0 0; font-size: 12px; }
.sms-composer-error { color: #b42318; }
.sms-composer-success { color: #087443; }
</style>
